import React from "react";

export default function DevicePreview() {
  return (
    <div className="flex h-full flex-col gap-2">
      <div className="grid grid-cols-2 gap-2">
        <div className="rounded-[18px] border border-violet-100 bg-white/80 p-3 dark:border-violet-500/10 dark:bg-black/10">
          <div className="text-[11px] text-gray-500 dark:text-gray-400">
            장비명
          </div>
          <div className="mt-1 text-[12px] font-semibold">cam01</div>
          <div className="mt-2 text-[10px] text-emerald-600 dark:text-emerald-300">
            ONLINE
          </div>
        </div>

        <div className="rounded-[18px] border border-violet-100 bg-white/80 p-3 dark:border-violet-500/10 dark:bg-black/10">
          <div className="text-[11px] text-gray-500 dark:text-gray-400">
            장비명
          </div>
          <div className="mt-1 text-[12px] font-semibold">cam02</div>
          <div className="mt-2 text-[10px] text-amber-600 dark:text-amber-300">
            CHECK
          </div>
        </div>
      </div>

      <div className="flex-1 rounded-[18px] border border-violet-100 bg-white/80 p-3 dark:border-violet-500/10 dark:bg-black/10">
        <div className="grid grid-cols-3 gap-2 text-[10px] font-semibold text-gray-500 dark:text-gray-400">
          <div>장비</div>
          <div>상태</div>
          <div>배터리</div>
        </div>

        <div className="mt-2 space-y-1.5">
          {[
            ["cam03", "정상", "91%"],
            ["cam04", "정상", "84%"],
            ["cam05", "점검", "67%"],
          ].map((row) => (
            <div
              key={row[0]}
              className="grid grid-cols-3 gap-2 rounded-xl bg-white/70 px-3 py-1.5 text-[10px] dark:bg-white/5"
            >
              <div>{row[0]}</div>
              <div>{row[1]}</div>
              <div>{row[2]}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}